module.exports = __webpack_public_path__ + "img/banner_01.1a00fde0.png";